import { Card, Skeleton } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import ChangeRequestApiService from '../../../../api/ChangeRequestApiService';
import ChangeRequestLayout from '../../../../components/postSecondary/ChangeRequestLayout';
import ProgramModificationChangeRequestStep4Form from '../../../../components/forms/postSecondary/ProgramModificationChangeRequestStep4Form';
import Routes from '../../../../config/Routes';
import * as GetBaseChangeRequestDetailsHandler from '../../../../handlerModels/GetBaseChangeRequestDetailsHandler';
import ChangeRequestDTO from '../../../../models/ChangeRequestDTO';
import InstitutionDTO from '../../../../models/InstitutionDTO';
import UserSecurity from '../../../../models/UserSecurity';
import BaseFormState from '../../../../redux/bases/BaseFormState';
import { StateStoreModel } from '../../../../redux/state/StateStoreModel';
import Guid from '../../../../utils/Guid';
import HistoryUtil from '../../../../utils/HistoryUtil';
import ParameterUtil from '../../../../utils/ParameterUtil';

interface ProgramModificationChangeRequestStep4PageState extends BaseFormState {
  changeRequestId: string;
  awardId: string;
  changeRequest: ChangeRequestDTO;
  isAwardNew: boolean;
}

interface ProgramModificationChangeRequestStep4PageProps {
  selectedInstitution: InstitutionDTO | null;
  currentUser: UserSecurity | null;
}

class ProgramModificationChangeRequestStep4Page extends React.Component<ProgramModificationChangeRequestStep4PageProps & RouteComponentProps<RouteObject>, ProgramModificationChangeRequestStep4PageState> {

  constructor(props: ProgramModificationChangeRequestStep4PageProps & RouteComponentProps<RouteObject>) {
    super(props);

    this.state = {
      isAwardNew: false,
      changeRequestId: Guid.Empty(),
      awardId: Guid.Empty(),
      changeRequest: ChangeRequestDTO.create(),
    };
  }

  componentDidMount() {
    const id = ParameterUtil.getPathPart(this.props.match, 'id');
    const awardId = ParameterUtil.getPathPart(this.props.match, 'awardId');

    if (id == 'new') {
      this.setState({ isNew: true });
    }
    else if (id !== Guid.Empty() && this.state.changeRequestId != id) {
      this.setState({ changeRequestId: id });
      this.fetchData(id);
    }

    if (awardId == ' new') {
      this.setState({ isAwardNew: true })
    }
    else if (awardId !== Guid.Empty() && this.state.awardId != awardId) {
      this.setState({ awardId: awardId });
    }
  }

  private fetchData = (id: string) => {
    this.setState({ loading: true });

    const loaders = [];

    if (id !== Guid.Empty()) {
      loaders.push(this.loadChangeRequest(id));
    }

    Promise.all(loaders).then(() => {
      this.setState({ loading: false });
    });
  }

  private loadChangeRequest = (id: string) => {
    return ChangeRequestApiService.getBaseChangeRequestDetails(id)
      .then((results: GetBaseChangeRequestDetailsHandler.Result) => {
        if (results) {
          this.setState({
            changeRequest: results.changeRequest ?? ChangeRequestDTO.create(),
          });
        }
      }).catch(() => {
        this.setState({ error: true, message: 'Could not load change request.' });
      });
  }

  private programModificationSave = () => {
    this.setState({ isEditing: false });


    this.loadChangeRequest(this.state.changeRequestId);

  }

  private goToPreviousStep = () => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_PROGRAM_MODIFICATION_CHANGE_REQUEST_ENTRY_3, { id: this.state.changeRequestId, awardId: this.state.awardId }, {}))
  }

  private goToNextStep = (id: string) => {
    HistoryUtil.push(Routes.generate(Routes.EXISTING_PROGRAM_MODIFICATION_CHANGE_REQUEST_ENTRY_2, { id: id }));
  }

  render() {
    if (this.state.loading || this.state.loading == undefined) {
      return <Skeleton active={true} />;
    }

    return (
      <Content >
        <ChangeRequestLayout
          changeRequest={this.state.changeRequest ?? ChangeRequestDTO.create()}
          awardId={this.state.awardId}
          stepNumber={3}
          currentUser={this.props.currentUser ?? {} as UserSecurity}>
          <Card title="Term Details" >
            <ProgramModificationChangeRequestStep4Form
              changeRequestId={this.state.changeRequest.id}
              awardId={this.state.awardId}
              selectedInstitution={this.props.selectedInstitution ? this.props.selectedInstitution.id : this.state.changeRequest.institutionId}
              loading={this.state.loading}
              onPrevious={this.goToPreviousStep}
              onSubmit={this.goToNextStep}
              onSave={this.programModificationSave}
            />
          </Card>
        </ChangeRequestLayout>
      </Content >
    );
  }
}

function mapDispatchToProps() {
  return {
  };
}

function mapStateToProps(state: StateStoreModel) {
  return {
    selectedInstitution: state.Institution.Selected,
    currentUser: state.UserSession.Value
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProgramModificationChangeRequestStep4Page));